import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  patchBundleRating,
  type PatchBundleRatingsResponse,
  type PatchBundleRatingsPostBody,
} from '@hungryroot/rest/api/v2/customers/[id]/bundle_ratings/[bundle_id]/patch';

type UsePatchBundleRatingsMutationProps<Context> = Omit<
  UseMutationOptions<
    PatchBundleRatingsResponse,
    Error,
    PatchBundleRatingsPostBody,
    Context
  >,
  'mutationFn'
>;

export function usePatchBundleRatingsMutation<Context>(
  props?: UsePatchBundleRatingsMutationProps<Context>
) {
  return useMutation({
    mutationFn: async (params: PatchBundleRatingsPostBody) => {
      const res = await patchBundleRating(params);
      if (res.status !== StatusCode.SuccessOK) {
        throw res;
      }
      return res.data;
    },
    ...props,
  });
}
